module.exports = __webpack_public_path__ + "static/media/line.6d0e4bac.jpg";